import { render, staticRenderFns } from "./addPopup2.vue?vue&type=template&id=17d8a633&scoped=true&"
import script from "./addPopup2.vue?vue&type=script&lang=js&"
export * from "./addPopup2.vue?vue&type=script&lang=js&"
import style0 from "./addPopup2.vue?vue&type=style&index=0&id=17d8a633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8a633",
  null
  
)

export default component.exports